<template>
  <div>
    <div class="tabela">
      <div class="titulo-tabela">
        <div v-if="expandir" @click="abreFechaTodos()" class="coluna">
          <font-awesome-icon class="ver-mais" icon="plus-circle" />
        </div>
        <div
          :class="[
            'coluna ',
            { 'ordem-crescente': strOrdem == item.valor && !reverse },
            { 'ordem-decrescente': strOrdem == item.valor && reverse }
          ]"
          v-for="item in colunas"
          @click="emitOrdenar(item.valor)"
        >
          {{ item.titulo }}
        </div>
      </div>
      <div v-for="linha in conteudo">
        <div class="linha">
          <div v-if="expandir" class="coluna" @click="abreFechaIndividual(linha)">
            <div v-if="linha.blShow == false || !linha.blShow">
              <font-awesome-icon class="ver-mais" icon="plus-circle" />
            </div>
            <div v-else>
              <font-awesome-icon class="ver-mais" icon="minus-circle" />
            </div>
          </div>
          <div
            :class="[
              'coluna ',
              { 'descricao': item.valor == 'descricao' },
            ]"
            v-for="item in colunas"
          >
            <span>{{ linha[item.valor] ? linha[item.valor] : "-" }} </span>
          </div>
        </div>
        <div v-if="expandir && linha.blShow == true">
          <div class="obs-expandido">
            <span
              class="monitoria-descricao"
              v-html="linha.observacao.replaceAll('<a ', '<a target=\'_blank\' ')"
            >
            </span>
            <span class="monitoria-base">
              <b class="mr-1">Base legal:</b
              ><span v-html="linha.base_legal_mudanca.replaceAll('<a ', '<a target=\'_blank\' ')">
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabela",
  props: {
    conteudo: {},
    colunas: {},
    tipo: "",
    expandir: ""
  },
  data() {
    return {
      strOrdem: "",
      reverse: false
    };
  },
  created() {},

  mounted() {},
  watch: {},
  computed: {
    baseLegal() {
      if (!this.dado) {
        return null;
      }
      if (!this.dado.base_legal) {
        return null;
      }

      return this.strReplace(this.dado.base_legal, "<a ", "<a target='_blank' ");
    }
  },

  methods: {
    emitOrdenar(strOrdem) {
      this.$emit("emitOrdenar", strOrdem);
      this.strOrdem = strOrdem;
      this.reverse = !this.reverse;
    },

    abreFechaIndividual: function(p) {
      if (p.blShow == true) {
        this.intMonitoriasAbertas--;
        p.blShow = false;
      } else {
        this.intMonitoriasAbertas++;
        p.blShow = true;
      }
      this.$forceUpdate();
    },

    abreFechaTodos: function() {
      if (this.conteudo.length != this.intMonitoriasAbertas) {
        this.conteudo.forEach(p => {
          p.blShow = true;
        });
        this.intMonitoriasAbertas = this.conteudo.length;
      } else {
        this.conteudo.forEach(p => {
          p.blShow = false;
        });
        this.intMonitoriasAbertas = 0;
      }
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
.ver-mais {
  user-select: none;
  cursor: pointer;
}
.tabela {
  display: grid;
  grid-template-rows: auto 1fr;
  border: 1px solid #ddd;
  border-radius: 2px;
  //   gap: 1rem;
}
.titulo-tabela {
  user-select: none;
  cursor: pointer;
  display: grid;
  // grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-template-columns: 1fr 3fr 3fr 3fr 3fr 3fr 9fr 3fr;
  gap: 1rem;
  border-radius: 2px;
  padding: 0 0.5rem;
  height: 2rem;
  color: var(--branco);
  background-color: var(--azul4) !important;
  // font-weight: bold;
}
.linha {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 3fr 3fr 3fr 9fr 3fr;
  gap: 1rem;
  border-top: 1px solid #ddd;
  border-radius: 2px;
  padding: 0.5rem;
  background-color: var(--branco);
}
.linha:hover {
  background-color: #00c1da15;
}
.tabela:last-child {
  border-bottom: 1px solid #ddd;
}
.coluna {
  display: flex;
  align-items: center;
  justify-content: center;
}

.obs-expandido {
  padding: 20px 50px 20px 50px;
  background: #e9e7e785;
}
.ordem-crescente {
  background: linear-gradient(var(--azul4), var(--azul3));
}
.ordem-decrescente {
  background: linear-gradient(var(--azul3), var(--azul4));
}
.descricao{
  display: flex;
 justify-content: left;
}
</style>
